import React, { useEffect, useState } from "react";
import {
  Table,
  Input,
  Button,
  Row,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from "reactstrap";

import axios from "axios";
import { submitBooksData } from "./utils/api";

const BooksRentalList = () => {
  const userData = JSON.parse(sessionStorage.getItem("userData")) || {};
  const [transactions, setTransactions] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [newStatus, setNewStatus] = useState("Returned");
  const [loading, setLoading] = useState(false);
    const baseUrl = `${process.env.REACT_APP_COLLEGE_ERP_API}books`;

  const itemsPerPage = 10;

  const fetchData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_COLLEGE_ERP_API}library_transaction`,
        {
          params: {
            branch: userData.branch,
            page,
            limit: itemsPerPage,
            search,
          },
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        }
      );

      setTransactions(res.data.data || []);
      setTotalPages(res.data.totalPages || 1);
    } catch (err) {
      console.error("Error fetching transactions", err);
    }
  };

  useEffect(() => {
    if (userData?.branch && userData?.token) {
      fetchData();
    }
  }, [userData?.branch, page, search]);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setPage(1); // reset to page 1 on new search
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

    const handleStatusUpdate = async (book, tx, newStatus) => {
  const confirmUpdate = window.confirm(
    `Are you sure you want to change this book's status to "${newStatus}"?`
  );
  if (!confirmUpdate) return;

  try {
    // Step 1️⃣ Update Transaction first
    await axios.put(
      `${process.env.REACT_APP_COLLEGE_ERP_API}library_book_status`,
      { Availability: newStatus },
      {
        params: {
          branch: userData.branch,
          transactionId: tx.Transaction_ID,
          id: book._id, // backend uses this to locate the book within transaction
        },
        headers: {
          Authorization: `Bearer ${userData.token}`,
        },
      }
    );

    // Step 2️⃣ Then update the Book using reusable helper
    const formData = {
      ...book,
      Availability: newStatus
    };

    await submitBooksData(
      `${process.env.REACT_APP_COLLEGE_ERP_API}books`,
      formData,
      {
        branch: userData.branch,
        token: userData.token,
        editData: true, // because we're updating
      }
    );

    // Step 3️⃣ Update UI
    setTransactions((prev) =>
      prev.map((t) =>
        t._id === tx._id
          ? {
              ...t,
              Books: t.Books.map((b) =>
                b._id === book._id
                  ? { ...b, Availability: newStatus }
                  : b
              ),
            }
          : t
      )
    );

    alert("Book status updated successfully.");
  } catch (err) {
    console.error("Error updating status:", err);
    alert("Failed to update book status. Please try again.");
  }
};

  return (
    <div>
      <Row className="mb-3">
        <Col md={6}>
          <Input
            type="text"
            placeholder="Search by Member ID, Transaction ID, Book Title, etc."
            value={search}
            onChange={handleSearchChange}
          />
        </Col>
      </Row>

      <Table striped bordered responsive>
        <thead>
          <tr>
            <th>#</th>
            <th>Transaction ID</th>
            <th>Member ID</th>
             <th>Member Name</th>
            <th>Books</th>
            <th>Issue Date</th>
            <th>Delivery</th>
              
          </tr>
        </thead>
        <tbody>
          {transactions.length === 0 ? (
            <tr>
              <td colSpan="6" className="text-center">
                No records found.
              </td>
            </tr>
          ) : (
            transactions.map((tx, index) => (
              <tr key={tx._id}>
                <td>{(page - 1) * itemsPerPage + index + 1}</td>
                <td>{tx.Transaction_ID}</td>
                <td>{tx.Member_ID}</td>
                <td>{tx.Member_Name}</td>
                <td>
                  <ul style={{ paddingLeft: "1rem" }}>
                    {tx.Books?.map((book, i) => (
                      <li key={i}>
                        <strong>{book.Book_Title}</strong> (
                        <span
                          className={
                            book.Availability === "Issued"
                              ? "text-danger"
                              : "text-success"
                          }
                        >
                          {book.Availability}
                        </span>
                        ){/* Dropdown for updating availability */}
                        <select
                          className="form-select d-inline w-auto ms-2"
                          value={book.Availability}
                          onChange={async (e) => {
                            const newStatus = e.target.value;

                            // Prompt user before making API call
                            const confirmUpdate = window.confirm(
                              `Are you sure you want to change this book's status to "${newStatus}"?`
                            );

                            if (!confirmUpdate) {
                              return; // stop if cancelled
                            }
                             if (confirmUpdate) {
                               handleStatusUpdate(book,tx,newStatus);
                            }

                            
                          }}
                        >
                          <option value="Issued">Issued</option>
                          <option value="Returned">Returned</option>
                          <option value="Pending">Pending</option>
                          <option value="Delivered">Delivered</option>
                        </select>
                      </li>
                    ))}
                  </ul>
                </td>
                <td>{new Date(tx.Issue_Date).toLocaleDateString("en-IN")}</td>
                 <td>{tx.Delivery_Mode}</td>
              </tr>
            ))
          )}
        </tbody>
      </Table>

      {/* Pagination Controls */}
      <Pagination>
        <PaginationItem disabled={page === 1}>
          <PaginationLink first onClick={() => handlePageChange(1)} />
        </PaginationItem>
        <PaginationItem disabled={page === 1}>
          <PaginationLink previous onClick={() => handlePageChange(page - 1)} />
        </PaginationItem>

        {[...Array(totalPages)].map((_, i) => (
          <PaginationItem active={page === i + 1} key={i}>
            <PaginationLink onClick={() => handlePageChange(i + 1)}>
              {i + 1}
            </PaginationLink>
          </PaginationItem>
        ))}

        <PaginationItem disabled={page === totalPages}>
          <PaginationLink next onClick={() => handlePageChange(page + 1)} />
        </PaginationItem>
        <PaginationItem disabled={page === totalPages}>
          <PaginationLink last onClick={() => handlePageChange(totalPages)} />
        </PaginationItem>
      </Pagination>
    </div>
  );
};

export default BooksRentalList;
